
import { graphql, type ResultOf, type VariablesOf } from '@client/shared/graphql';
import { gqlRequest } from '@client/shared/graphql';

export const ListingForEditQuery = graphql(`
  query ListingForEdit($id: ID!) {
    listing(id: $id) {
      id
      formattedAddress
      addressLine1
      addressLine2
      city
      region
      postalCode
      country
      placeId
      lat
      lng
      timezone
      showingNotes
      bookingHorizonDays
      bookingUntil
      bookingAccessKind
      bookingAccessUserIds
      notifyUserIds
    }
  }
`);

export type ListingForEditData = ResultOf<typeof ListingForEditQuery>;
export type EditableListing = NonNullable<ListingForEditData['listing']>;

export function listingForEditKey(id: string) {
  return ['listing', 'edit', id] as const;
}

export function fetchListingForEdit(id: string, signal?: AbortSignal): Promise<ListingForEditData> {
  return gqlRequest(ListingForEditQuery, { id }, { signal });
}

export const UpdateListingMutation = graphql(`
  mutation UpdateListing($id: ID!, $input: UpdateListingInput!) {
    updateListing(id: $id, input: $input) {
      id
      formattedAddress
      timezone
      bookingHorizonDays
    }
  }
`);

export type UpdateListingVariables = VariablesOf<typeof UpdateListingMutation>;
export type UpdateListingResult = ResultOf<typeof UpdateListingMutation>;
export type UpdateListingPatch = UpdateListingVariables['input'];
export type UpdatedListing = NonNullable<UpdateListingResult['updateListing']>;

export async function runUpdateListing(
  id: string,
  input: UpdateListingPatch,
): Promise<UpdatedListing> {
  const data = await gqlRequest(UpdateListingMutation, { id, input });
  const result = data.updateListing;
  if (!result) {
    throw new Error('This listing could not be found, or it isn’t in your group.');
  }
  return result;
}
